import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import "./plan.css";
import useFormValidation from "../../hooks/useFormValidator";
import { signUp } from "../../axios/signUp.axios";
import { useSelector, useDispatch } from "react-redux";
import { setTempUser } from "../../actions/signUp.actions";
import { NotificationContainer } from "react-notifications";
import { Link } from "react-router-dom";
import { products } from "../../products/products.details";

const OrderCheckoutSignUp = (props) => {
  // const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  const code = useSelector((state) => state.changeStep.affiliate);

  const [input, setInput] = useState({
    email: "",
    password: "",
    affiliate: "",
    package_name: "",
    isOrderCheckoutUser: true,
    user_type:""
  });

  const [validationReport, validate] = useFormValidation();

  const change = async (wizard) => {
    if (
      validationReport.email &&
      validationReport.email.isValid &&
      validationReport.password &&
      validationReport.password.isValid &&
      validationReport.package_name
    ) {
      props.loader(true);
      await signUp(input)
        .then((response) => {
          // console.log(response,"res")
          dispatch(setTempUser(response.data.data));
          props.changeWizard(wizard);
          props.loader(false);
        })
        .catch((err) => {
          //    alert(err.response.data.message)
          props.notify(err.response.data.message, false);
          props.loader(false);
        });
    } else {
    }
  };

  const handleChange = (event) => {
    let rules = JSON.parse(event.target.dataset.rules);

    validate(event.target.value, rules, event.target.name);
    if (event.target.name === "email") {
      setInput({
        ...input,
        [event.target.name]: event.target.value.toLowerCase(),
      });
    } else if(event.target.name === "package_name") {
      setInput({ ...input, package_name: event.target.value,user_type: event.target.selectedOptions[0]?.dataset?.type});
    
    } else {
      setInput({ ...input, [event.target.name]: event.target.value });
    }
  };

  function log() {
    console.log("report", validationReport);
  }

useEffect(() => {
  if (code) {
    setInput((prev) => ({
      ...prev,
      affiliate: code,
    }));
  }
}, [code]);

  return (
    <div className="sign_up_partts">
      <NotificationContainer />
      <h3>1. Sign Up</h3>
      <p>
        To purchase this plan and use its benefits in the future, log in to your
        account or sign up.
      </p>

      <Form>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            value={input.email}
            type="email"
            name="email"
            placeholder="Enter email address"
            className="sign_email"
            data-rules={JSON.stringify({
              required: true,
              email: true,
            })}
            onChange={(event) => {
              handleChange(event);
            }}
          />
          {validationReport.email && !validationReport.email.isValid ? (
            <small className="text-danger">
              {validationReport.email.errorMessage}{" "}
            </small>
          ) : (
            ""
          )}
          {log()}
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            value={input.password}
            name="password"
            type="password"
            placeholder="Password"
            className="sign_email"
            data-rules={JSON.stringify({
              required: true,
              password: true,
            })}
            onChange={(event) => {
              handleChange(event);
            }}
          />
          {validationReport.password && !validationReport.password.isValid ? (
            <small className="text-danger">
              {validationReport.password.errorMessage}{" "}
            </small>
          ) : (
            ""
          )}
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Choose Product</Form.Label>
          <Form.Select
            name="package_name"
            className="form-control"
            data-rules={JSON.stringify({
              required: true,
              package: true,
            })}
            required
            onChange={(event) => {
              handleChange(event);
              if (event.target.value) {
                if(event.target.value == "947"){
                  props.setProductOneTime(event);
                }else{
                  props.setProduct(event);
                }
              }
            }}
          >
            <option value="">Select Product</option>
            <option
              data-price={products.tvi[0].price}
              data-product_id={products.tvi[0].id}
              data-name={products.tvi[0].name}
              data-type={products.tvi[0].plan_type}
              value={products.tvi[0].id}
            >
              Monthly $97
            </option>
            <option
              data-price={products.tvi[1].price}
              data-product_id={products.tvi[1].id}
              data-name={products.tvi[1].name}
              data-type={products.tvi[1].plan_type}
              value={products.tvi[1].id}
            >
              3 Months $257
            </option>
            <option
              data-price={products.tvi[2].price}
              data-product_id={products.tvi[2].id}
              data-name={products.tvi[2].name}
              data-type={products.tvi[2].plan_type}
              value={products.tvi[2].id}
            >
              6 Months $497
            </option>
            {/* <option data-price={products.tvi[4].price} data-product_id={products.tvi[4].id} data-name={products.tvi[4].name} value="TVI12">TVI 12 Month Membership $947</option> */}
            <option
              // data-price={products.tvi[3].price}
              // data-product_id={products.tvi[3].id}
              // data-name={products.tvi[3].name}
              // data-type={products.tvi[3].plan_type}
              value={947}
            >
              TVI 12 Month Membership $947
            </option>
            {/* <option
              data-price={products.tvi[5].price}
              data-product_id={products.tvi[5].id}
              data-name={products.tvi[5].name}
              value={products.tvi[5].id}
            >
              TVI Star (yearly) $1,997
            </option>
            <option
              data-price={products.tvi[6].price}
              data-product_id={products.tvi[6].id}
              data-name={products.tvi[6].name}
              value={products.tvi[6].id}
            >
              TVI Star Experience (yearly) $4,997
            </option> */}

            {/* <option
              data-price={products.tvi[7].price}
              data-product_id={products.tvi[7].id}
              data-name={products.tvi[7].name}
              data-type={products.tvi[7].plan_type}
              value={products.tvi[7].id}
            >
              {products.tvi[7].name}
            </option>

            <option
              data-price={products.tvi[8].price}
              data-product_id={products.tvi[8].id}
              data-name={products.tvi[8].name}
              data-type={products.tvi[8].plan_type}
              value={products.tvi[8].id}
            >
              {products.tvi[8].name}
            </option>

            <option
              data-price={products.tvi[9].price}
              data-product_id={products.tvi[9].id}
              data-name={products.tvi[9].name}
              data-type={products.tvi[9].plan_type}
              value={products.tvi[9].id}
            >
              {products.tvi[9].name}
            </option>

            <option
              data-price={products.tvi[10].price}
              data-product_id={products.tvi[10].id}
              data-name={products.tvi[10].name}
              data-type={products.tvi[10].plan_type}
              value={products.tvi[10].id}
            >
              {products.tvi[10].name}
            </option> */}

          </Form.Select>
          {validationReport.package && !validationReport.package.isValid ? (
            <small className="text-danger">
              {validationReport.package.errorMessage}{" "}
            </small>
          ) : (
            ""
          )}
        </Form.Group>

        <div className="sign_submit flex-wrap justify-content-between align-items-center">
          <p className="mb-0">
            Already have an account? <Link to="/login">Login</Link>
          </p>
          {/* {show && <AdditionalInfo />} */}
          <Button
            variant="primary"
            type="button"
            onClick={() => {
              change("aInfo");
            }}
          >
            Next
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default OrderCheckoutSignUp;
